export enum OfficeExclusiveType {
  NONE = 'None',
  OFFICE_EXCLUSIVE = 'Office Exclusive Document',
}

export const OFFICE_EXCLUSIVE_SHORT_DESC = 'Office Exclusive Document';

export const OFFICE_EXCLUSIVE_FILENAME = 'Office Exclusive Agreement.pdf';
